import { useState } from 'react';
import { Outlet } from 'react-router';
import { Menu, X } from 'lucide-react';
import AshKeepSidebar from './AshKeepSidebar';
import Header from './Header';

export default function AshKeepShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="dashboard-layout">
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      <div className={sidebarOpen ? 'dashboard-sidebar open' : 'dashboard-sidebar'}>
        <AshKeepSidebar />
      </div>

      <div className="dashboard-main">
        <div className="mobile-header">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="mobile-menu-btn"
            aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
          >
            {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
          </button>
          <span className="mobile-title" style={{ color: '#921f46' }}>AshKeep</span>
        </div>
        <Header />
        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
